import { PAGE_MODE } from "../../../constants/constants";
import BarButtonFw, { BUTTON_DEFAULT, } from "../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../framework/form/FormFw";
import { BasePage } from "../../../framework/pages/BasePage";
import { DATE_FORMAT } from "../../../constants/constants";

class ProcedenciaMuestraModal extends BasePage {
  renderPage(pageApi) {

    const getform_procedencia = () => pageApi.getComponent('form_procedencia');

    const form_procedencia = {
      layout: 'vertical',
      load: {
        queryId: 354,
        params: { ID_CADENA: pageApi.getParamId() },
      },
      save: {
        queryId: 349,
      },
      update: {
        queryId: 951,
      },
      title: '',
      collapsible: true,
      fields: [
        {
          label: '  ',
          fields: [
            { type: 'hidden', name: 'id_doc' },
            { type: 'divider', label: 'Procedencia de la Muestra' },
            {name: 'nro_ss_cadena', label: ' ',column: 3,readOnly: true},  
            { name: "aa", label: "Muestreado por", value: "Inspectorate", column: 2, readOnly: true, },
            { name: "aa", label: "Info. brindada por", value: "Inspectorate", column: 2, readOnly: true, },
            { name: "nombre_proyecto", label: "Proyecto", column: 4, readOnly: true },
            { type: "select", name: "cod_departamento", label: "Departamento", column: 3, load: { queryId: 130 }, search: true, readOnly: true, },
            {
              type: "select", name: "cod_provincia", label: "Provincia", column: 2, load: { queryId: 133 }, search: true, readOnly: true,
              parents: [
                {
                  name: "cod_departamento",
                  paramName: "cod_departamento",
                  required: true,
                },
              ],
            },
            {
              type: "select", name: "cod_distrito", label: "Distrito", column: 2, readOnly: true, load: { queryId: 134, }, search: true,
              parents: [
                {
                  name: "cod_provincia",
                  paramName: "cod_provincia",
                  required: true,
                },
                {
                  name: "cod_departamento",
                  paramName: "cod_departamento",
                  required: true,
                },
              ],
            },
            { name: "lugar_muestreo", label: "Lugar Muestreo", column: 4, },
            { name: "referencia_muestra", label: "Referencia", column: 4, },
            { type: 'divider', label: 'Datos de envio de material' },
            { type: "date", name: "fecha_entrega", label: "Fecha", column: 2, format: "DD/MM/YYYY", inputFormat: DATE_FORMAT.YYYYMMDD, readOnly: true, },
            { name: "agencia_aerolinea", label: "Agencia/Aerolina/Otro", column: 3, readOnly: true },
            { type: 'divider', label: 'Datos de envío de la muestra' },
            { type: "date", name: "fecha_envio_muestra", label: "Fecha Envio Muestra", column: 2, format: "DD/MM/YYYY", inputFormat: DATE_FORMAT.YYYYMMDD },
            { type: "date", name: "hora_envio_muestra", label: "Hora Envio Muestra", column: 2, format: DATE_FORMAT.HHmm, inputFormat: DATE_FORMAT.HHmm, },
            { name: "agencia_aerea", label: "Agencia Aérea", column: 3 },
            { name: "agencia_terrestre", label: "Agencia Terrestre", column: 3 },
            { type: 'radio', name: "es_vehiculo_isp", label: "Vehículo ISP", column: 3, load: { dataList: [ { value: '1', label: 'Si' }, { value: '0', label: 'No' } ] } },
            { type: 'radio', name: "es_vehiculo_cliente", label: "Vehículo Cliente", column: 3, load: { dataList: [ { value: '1', label: 'Si' }, { value: '0', label: 'No' } ] } },
            { name: "placa_vehiculo_particular", label: "Vehículo Particular (placa)", column: 3 },
            { type: 'select', name: "cod_departamento_cadena", label: "Departamento", labelName: 'departamente', column: 3, load: { queryId: 130 }, },
          ]
        }
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW)
          formApi.load();
      }
    }

    const barButtonFooterprocedencia = {
      fields: [
        {
          ...BUTTON_DEFAULT.RETURN, label: 'Retornar Inicio', onClick: () => {
            const pathBack = this.props?.history?.location?.state?.from 
              || `/solicitudes-asignadas/solicitudes-asignadas/${pageApi.name.id_ss}`;
            this.props.history.push(pathBack);
          }
        },
        {
          ...BUTTON_DEFAULT.SAVE, label: 'Guardar', onClick: async () => {
            getform_procedencia().update({ params: getform_procedencia().getData() });
          },
        },
        {
          ...BUTTON_DEFAULT.NEXT, label: 'Continuar', onClick: () => {
            getform_procedencia().update({ params: getform_procedencia().getData() });
            this.props.cambiarTabPanel("4", 0);
          }
        },
      ]
    }

    return (
      <>
        <FormFw
          name="form_procedencia"
          getParentApi={pageApi.getApi}
          config={form_procedencia}
        />
        <BarButtonFw
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooterprocedencia}
        />
      </>
    );
  }
}
export default ProcedenciaMuestraModal